import axios from "axios";
import baseUrl from "./server";
import { getStoredAuthToken, hasValidAuthToken } from "../utils/authUtils";


// const axiosInstance = axios.create({
//     baseURL: baseUrl,
//     headers: {
//         Accept: "*/*",
//         "Content-Type": "application/json",
//         authorization: localStorage.getItem("token")
//     },

//     withCredentials: true,
// });




export const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        'Client-Base-URL': window.location.origin
    }
});

const token = getStoredAuthToken();

if (hasValidAuthToken(token)) {
  axiosInstance.defaults.headers.common.authorization = token;
} else {
  delete axiosInstance.defaults.headers.common.authorization;
}

export default axiosInstance;
